












import {Component, Prop, Vue} from 'vue-property-decorator'
import {Chart} from 'highcharts-vue'
import axios from 'axios';
import * as Highcharts from "highcharts";
import {Point, XAxisOptions} from "highcharts";
import {currency} from "@/util/formatter";

@Component({
    components: {highcharts: Chart}
})
export default class LineChart extends Vue {

    @Prop()
    dataEndpoint!: string;

    private readonly updateArgs = [true, true, true];

    private isLoading = true;
    private error: string | null = null;

    private chartOptions: Highcharts.Options = {
        xAxis: {
            categories: []
        },
        yAxis: {
            title: {
                text: '£ Amount'
            },
        },
        chart: {
            styledMode: true,
            spacingTop: 25,
            spacingBottom: 25,
        },
        exporting: {
            enabled: false
        },
        credits: {
            enabled: false
        },
        title: {
            text: ''
        },
        series: [],
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            valueDecimals: 2,
            pointFormatter: function() {
                let year = parseInt(this.series.name);
                if (this.x >= 9) {
                    year += 1;
                }
                const formatted = currency(this.y!);
                return `<span style="color: ${this.color};">●</span> ${year}: <b>${formatted}</b><br/>`;
            },
        }
    };

    private mounted() {
        this.loadData()
    }

    private loadData() {
        this.isLoading = true;
        this.error = null;

        axios.get(this.dataEndpoint)
            .then(result => {
                const data = result.data;

                (this.chartOptions.xAxis as XAxisOptions).categories = data.categories;
                const chartData = data.chartData as any[];
                this.chartOptions.series = chartData.map(lineData => {
                    const lineEntry = Object.keys(lineData)[0];
                    return <Highcharts.SeriesOptionsType> {
                        type: 'line',
                        name: lineEntry,
                        data: lineData[lineEntry]
                    };
                });
            })
            .catch(error => {
                const data = error.response.data;
                this.error = data.message || 'Could not load data for this report.';
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}
